import { PageHeader } from "@/components/PageHeader";
import { usePageTitle } from "@/hooks/usePageTitle";
import { RolesList } from "@/components/roles/RolesList";
import { useAllRoles } from "@/hooks/roles/useAllRoles";
import { usePersistedViewMode } from "@/utils/viewMode";
import { useTranslation } from "react-i18next";

const Roles = () => {
	usePageTitle("Roles");
	const { t } = useTranslation();
	const { roles, loading, error, searchTerm, setSearchTerm, refresh } = useAllRoles();
	const [viewMode, setViewMode] = usePersistedViewMode("roles");

	return (
		<div>
			<PageHeader title={t("roles.header")} />
			<RolesList
				roles={roles}
				loading={loading}
				error={error}
				searchTerm={searchTerm}
				setSearchTerm={setSearchTerm}
				viewMode={viewMode}
				setViewMode={setViewMode}
				onCompanyCreated={refresh}
			/>
		</div>
	);
};

export default Roles;
